module.exports = __webpack_public_path__ + "img/Support Actions.e20cad47.png";